import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

const baseUrl = `${API_BASE_URL}/integrations/checkbox`;

export const getCheckboxGlobalSettings = async () => {
    const response = await axios.get(`${baseUrl}/global-settings`, getAuthHeaders());
    return response.data;
};

export const updateCheckboxGlobalSettings = async (payload) => {
    const response = await axios.put(`${baseUrl}/global-settings`, payload, getAuthHeaders());
    return response.data;
};

export const importCheckboxEnvSettings = async () => {
    const response = await axios.post(`${baseUrl}/import-env`, {}, getAuthHeaders());
    return response.data;
};

export const forceCreateCheckboxReceipt = async (salesdriveOrderNumber) => {
    const response = await axios.post(
        `${baseUrl}/force-receipt`,
        { salesdrive_order_number: salesdriveOrderNumber },
        getAuthHeaders()
    );
    return response.data;
};
